<div class="chatter-provided-set">
  <button mat-raised-button
          (click)="select(option)"
          class="chatter-provided-set__option"
          *ngFor="let option of setToProvide"
          [ngClass]="{'selected': option === selected}">
    {{option}}
  </button>
</div>
